import { clearTimelineCache, pathAffectsTimeline } from './utils/timelineCache';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

async function request(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  const method = (options.method || 'GET').toUpperCase();

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    credentials: 'include',
  });

  if (res.status === 401) {
    const body = await res.json().catch(() => ({}));
    // Only treat as session-expired for non-auth endpoints; auth routes
    // return 401 for token validation failures (different meaning).
    if (!path.startsWith('/auth/')) {
      window.dispatchEvent(new CustomEvent('auth:expired'));
    }
    throw new Error(body.detail || 'Session expired. Please sign in again.');
  }

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.detail || `API error ${res.status}`);
    err.status = res.status;
    throw err;
  }

  // A successful mutation of timeline-relevant data invalidates the cached
  // dashboard snapshot, so the next dashboard visit reloads fresh.
  if (method !== 'GET' && pathAffectsTimeline(path)) {
    clearTimelineCache();
  }

  return res.json();
}

export function get(path) {
  return request(path);
}

export function post(path, data) {
  return request(path, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function put(path, data) {
  return request(path, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

export function del(path) {
  return request(path, { method: 'DELETE' });
}

const api = { get, post, put, del };
export default api;
